<template>
    <div class="contents">
        <div class="customer_wrap">
            <div class="cs_card">
                <div class="box">
                    <img src="../../assets/images/common/ico_cs.png" alt="고객센터 이용안내">
                    <p>고객센터 이용안내</p>
                    <h5>070.4233.0655</h5>
                    <span>FAX : 02)478-5822</span>
                </div>
                <p>운영시간</p>
                <span>월-금 09:00~17:30</span>
            </div>
            <div class="cs_tab">
                <CustomerServiceNavigation/>
                <div class="cs_tabPanel active" id="cs_tab01">
                    <h5 class="title">공지사항</h5>
                    <div class="search_wrap">
                        <div class="select_box">
                            <button type="button" class="btn_select" :class="showSelect ? 'on' : ''" @click="toggleSelect">{{ currentOption.name }}</button>
                            <ul class="select_list">
                                <li v-for="option in searchOptions"><button @click="selectOption(option)">{{ option.name }}</button></li>
                            </ul>
                        </div>
                        <span class="search_box">
                            <input type="text" placeholder="검색어를 입력 해주세요." v-model="searchInput">
                            <button type="button" @click="getSearch">검색버튼</button>
                        </span>
                    </div>
                    <div class="tbl_wrap">
                        <table class="basic">
                            <colgroup>
                                <col style="width: 11%;">
                                <col style="width: 54%;">
                                <col style="width: 20%;">
                                <col style="width: 15%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>번호</th>
                                    <th>제목</th>
                                    <th>작성일</th>
                                    <th>조회</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="notice in notices"
                                    @click="toNotice(notice.noticeSeq)"
                                >
                                    <td :class="notice.topNoticeYn === 'Y' ? 'noti' : 'num'">{{ notice.topNoticeYn === 'Y' ? '공지' : notice.order }}</td>
                                    <td class="title">{{ notice.title }}</td>
                                    <td class="date">{{ notice.createDate }}</td>
                                    <td>{{ notice.viewCnt }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <CustomerServicePagination
                        :totalPages = "totalPages()"
                        :currentPage = currentPage
                        @changePage = "changePage"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CustomerServicePagination from '../common/CustomerServicePagination.vue';
import CustomerServiceNavigation from '@/views/customerService/layout/CustomerServiceNavigation.vue';


const noticeModule = 'noticeModule'

export default {
  components: {
    CustomerServicePagination,
    CustomerServiceNavigation
  },

  data () {
    return {
      showSelect: false,
      searchOptions: [
        { name: '전체', value: 'all' },
        { name: '제목', value: 'title' },
        { name: '내용', value: 'content' },
      ],
      searchType: 'all',
      searchWord: '',
      searchInput: '',
      currentSearch: '',
      currentPage: 1,
      currentOption: {
        name: '전체', value: 'all'
      }
    }
  },

  methods: {
    ...mapActions(noticeModule, [
        'requestNoticeList'
    ]),

    toggleSelect () {
      if (this.showSelect) {
        this.showSelect = false
      } else {
        this.showSelect = true
      }
    },

    selectOption(option) {
      this.currentOption = option
      this.showSelect = false
    },

    totalPages () {
      return Math.ceil(this.noticeCount / 10);
    },

    async changePage (page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestNoticeList({currentPage, searchType, searchWord})
    },

    async getSearch(){ 
        this.searchWord = this.searchInput
        this.currentPage = 1
        const {currentPage, searchType, searchWord} = this
        await this.requestNoticeList({currentPage, searchType, searchWord})
    },

    toNotice (noticeSeq) {
        this.$router.push({
            name: 'NoticeDtlPage',
            params: { noticeSeq: noticeSeq.toString() }
        })
    },

    toPage(pageName) {
      this.$router.push({ name: pageName })
    }
  },

  computed: {
    ...mapState(noticeModule, [
        'notices',
        'noticeCount'
    ])
  },

  watch: {
    currentOption(newVal) {
        this.searchType = newVal.value
    }
  },

  async mounted () {
    const {currentPage, searchType, searchWord} = this
    await this.requestNoticeList({currentPage, searchType, searchWord})
  }
}
</script>
<style lang="">
    
</style>